import get from 'lodash/get';
import { useQuery } from '@apollo/client/react';
import { FinancingDocument } from 'graphql/generated/graphql';

const useGetFinancing = (projectId: string) => {
  const { loading, data } = useQuery(FinancingDocument, {
    variables: { id: projectId },
    fetchPolicy: 'cache-and-network',
  });

  const budget = get(data, 'myBudget', null);
  const project = get(data, 'project', null);

  const financing = { project, budget };

  return [financing, loading] satisfies [typeof financing, boolean];
};

export default useGetFinancing;
